define('modules/stats/models/statistic',['require','exports','module','backbone','env'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
    config = require('env');

  module.exports = Backbone.Model.extend({
    urlRoot: [config.apiHost, 'statistics'].join('/'),
    defaults: {},
    initialize: function (options) {},
  });
});

